module.exports = __webpack_public_path__ + "static/img/vEight4.a6361fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vEight4.png
// module id = gSbM
// module chunks = 2